import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white py-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-screen-md mx-auto px-4 text-center md:flex my-auto" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold w-full text-center" }, " Wählen Sie einen Diamant für Ihr Produkt: ")
], -1)
const _hoisted_3 = { class: "max-w-screen-md mx-auto px-4 text-center md:flex my-auto" }
const _hoisted_4 = { class: "md:flex-grow my-auto md:order-2" }
const _hoisted_5 = { class: "w-full text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 mx-auto text-brand-main" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "size-6"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "w-full md:w-32 my-auto md:order-3" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "max-w-screen-md mx-auto px-4 my-4 md:my-0"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 text-brand-main mx-auto" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "size-6"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 18.75 7.5-7.5 7.5 7.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 12.75 7.5-7.5 7.5 7.5"
    })
  ])
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_conf_item_image = _resolveComponent("conf-item-image")!
  const _component_conf_item_description_parts = _resolveComponent("conf-item-description-parts")!

  return (_ctx.item.desc)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.item.desc.description), 1),
            (!_ctx.showDetails)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails = true)),
                  class: "text-center my-2 cursor-pointer"
                }, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          (_ctx.itemImage.filename)
            ? (_openBlock(), _createBlock(_component_conf_item_image, {
                key: 0,
                "image-url": _ctx.itemImage.filename,
                "image-layer-url": _ctx.itemImage.filename_layer,
                class: "md:w-32 w-64 md:order-1 mx-auto"
              }, null, 8, ["image-url", "image-layer-url"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: '/konfigurator/next/#/conf/' + _ctx.confSession,
              class: "w-full uppercase text-sm bg-brand-main text-white border border-brand-main py-1 px-8 flex items-center justify-center hover:text-brand-text hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-main"
            }, "abbrechen", 8, _hoisted_9)
          ])
        ]),
        (_ctx.showDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_conf_item_description_parts, {
                "parts-list": _ctx.item.desc.parts
              }, null, 8, ["parts-list"]),
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetails = false)),
                class: "mx-auto w-full cursor-pointer"
              }, _hoisted_12)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}